const STORAGE_KEY = "r2c2_wifi_saved_passwords_v1";

type Store = Record<string, string>;

function entryKey(baseUrl: string, ssid: string): string {
    return `${baseUrl}\0${ssid}`;
}

function readStore(): Store {
    if (typeof window === "undefined") return {};
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw) as unknown;
        if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
            return parsed as Store;
        }
    } catch {
        /* ignore corrupt storage */
    }
    return {};
}

function writeStore(store: Store): void {
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch {
        /* quota / private mode */
    }
}

/** Password remembered after a successful connect in this browser (per robot API base + SSID). */
export function getStoredWifiPassword(baseUrl: string | null, ssid: string): string | null {
    if (!baseUrl?.trim() || !ssid.trim()) return null;
    const psk = readStore()[entryKey(baseUrl.trim(), ssid.trim())];
    return psk?.length ? psk : null;
}

export function rememberWifiPassword(
    baseUrl: string | null,
    ssid: string,
    password: string
): void {
    if (!baseUrl?.trim() || !ssid.trim()) return;
    const key = entryKey(baseUrl.trim(), ssid.trim());
    const store = readStore();
    const trimmed = password.trim();
    if (!trimmed) {
        if (key in store) {
            delete store[key];
            writeStore(store);
        }
        return;
    }
    store[key] = trimmed;
    writeStore(store);
}
